import React from "react";
import styled from "styled-components";
import StepIndicator from "./StepIndicator";

function PageHeader({
  currentPage,
  totalPages = 3,
  onClose,
  onSaveDraft,
  saveDraftDisabled = false,
  saveDraftLabel = "SAVE AS DRAFT",
  showSaveDraft = true,
}) {
  return (
    <>
      <Header>
        <Left>
          <IconButton type="button" onClick={onClose} aria-label="Close">
            ×
          </IconButton>
        </Left>
        <Center>
          <StepIndicator current={currentPage} total={totalPages} />
        </Center>
        <Right>
          {showSaveDraft && (
            <DraftButton
              type="button"
              onClick={onSaveDraft}
              disabled={saveDraftDisabled}
            >
              {saveDraftLabel}
            </DraftButton>
          )}
        </Right>
      </Header>
      <Separator />
    </>
  );
}

export default PageHeader;

const Header = styled.div`
  width: 100%;
  padding: 16px 24px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--color-border);
  margin-bottom: 30px;

  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const IconButton = styled.button`
  font-family: "Roboto", sans-serif;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--color-background);
  }
`;

const DraftButton = styled.button`
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 700;
  border: none;
  background: transparent;
  color: var(--color-primary);
  cursor: pointer;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};

  &:disabled {
    cursor: not-allowed;
  }
`;
